// en_US.js
const en_US = {
    // homepage
    homepage_title: 'CalendarTask mobile version download',
    homepage_slogn: 'CalendarTask mobile version',
    homepage_ios_download: 'AppStore review...',
    homepage_download: 'Download',


    // 手机下载
    phonedownload_title: 'CalendarTask Mobile Download',
     phonedownload_slogan: 'The mobile version of the CalendarTask can be synchronized with the computer version of the CalendarTask in real time to record trivia anytime, anywhere.',
     phonedownload_send_vip: 'Install App, send VIP members',
     phonedownload_screenshot: 'Screenshot',
     phodedownload_macos: 'CalendarTask macOS computer version',
     phodedownload_windows: 'CalendarTask windows computer version',
     phodedownload_otherbutton: "View Now",
     phodedownload_about: 'Contact Us',
    phodedownload_copyright: ' ',

    //特点
    feature_no_ad: 'No ads',
    feature_easy: 'Easy to use',
    feature_reminder: 'Custom Reminder',
    feature_countdown: 'Countdown Day',

    vip_task_succ:'Accept successful, please download the mobile version to activate VIP',
    vip_task_error:'Accept failed ',
    
    group_slogn : "日历清单团队版邀请",
    
    //课程表
    tt_title: 'CalendarTask',
    tt_share_1: 'Shared with you',
    tt_share_2: 'Timetable',
    tt_share_show_1: 'Scan the QR code with "CalendarTask" app,and your desktop and mobile will show the',
    tt_share_show_2: '\'s timetable',
    tt_share_scan_1: 'Scan with',
    tt_share_scan_2: '"CalendarTask" app',
    tt_share_succ: 'Sync successful',
    
    // V2版权信息
    v2_copyright: 'Contact us service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. All rights reserved.',
    v2_download_appstore: 'Download on the App Store',
    v2_download_googleplay: 'GET IT ON Google Play',
    
    // V2中间部分内容
    v2_main_title: 'CalendarTask Mobile',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Mobile',
    v2_main_description: 'You can search for <span class="name">CalendarTask</span> in the App Store or Google Play and download it.',
    v2_download_ios: 'Download iOS',
    v2_download_android: 'Download Android',
    v2_download_harmonyos: 'Download HarmonyOS',
    v2_sync_status: 'Sync completed! Upload 1 record, Download 0 records',
    v2_feature_title: 'Multi-device Data Sync',
    v2_feature_description: 'Real-time data synchronization across mobile, tablet, computer and other devices'

}
export default en_US;